import { useCallback, useState } from "react";

import isNil from "lodash/isNil";

import { HomeAnalyticsEvent } from "@/constants/analytics/Analytics";
import {
  UnencryptedStorageKey,
  useUnencryptedStorage,
} from "@/hooks/useUnencryptedStorage";
import type { WebRedesignOverviewStorageKey } from "@/hooks/useUnencryptedStorage";
import { useAnalytics } from "@/services/Analytics";
import { isWeb } from "@/utils/platform.util";

const buildStorageKey = (appUserId: string): WebRedesignOverviewStorageKey =>
  `${UnencryptedStorageKey.WebRedesignOverviewDismissed}_${appUserId}`;

const useWebRedesignOverviewModal = (appUserId: string) => {
  const { track } = useAnalytics();
  const { getUnencryptedBooleanValue, saveUnencryptedBooleanValue } =
    useUnencryptedStorage();

  const [shouldShowModal, setShouldShowModal] = useState(
    () =>
      isWeb() &&
      !isNil(appUserId) &&
      !getUnencryptedBooleanValue(buildStorageKey(appUserId)),
  );

  const handleDismiss = useCallback(() => {
    setShouldShowModal(false);
    saveUnencryptedBooleanValue({
      isTrue: true,
      key: buildStorageKey(appUserId),
    });
    track(HomeAnalyticsEvent.WebRedesignOverviewDismissed);
  }, [appUserId, saveUnencryptedBooleanValue, track]);

  return {
    handleWebRedesignOverviewDismiss: handleDismiss,
    shouldShowWebRedesignOverview: shouldShowModal,
  };
};

export default useWebRedesignOverviewModal;
